export default __webpack_public_path__ + "assets/img/5a12e1ea04d2c3fc9b63b3e5697ce674.svg";